import React from "react";
import NavBar from "../components/NavBarOthers";

const ContactPage = () => {
  return (
    <>
      <NavBar />
      <div className="mt-24 mx-10">
        <h1>Hello There</h1>
      </div>
    </>
  );
};

export default ContactPage;
